module.exports = __webpack_public_path__ + "img/home_blue.30688183.svg";